// Module
var code = "<template>\n  <require from=\"bootstrap/dist/css/bootstrap.min.css\"></require>\n  <require from=\"@fortawesome/fontawesome-free/css/all.min.css\"></require>\n  <require from=\"./Components/styles.less\"></require>\n\n  <div>\n    <router-view></router-view>\n  </div>\n</template>\n";
// Exports
export default code;